/** Shopify CDN: Minification failed

Line 59:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 60:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 124:9 Transforming let to the configured target environment ("es5") is not supported yet
Line 125:6 Transforming let to the configured target environment ("es5") is not supported yet

**/
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $(function() {
  element = document.getElementsByClassName('popup-custom');
  targetNode = element[0];
  config = { childList: true, attributes: true, subtree: true };
  callback = function(mutationList, observer) {
  	mutationList.forEach((mutation) => {
        switch(mutation.type) {
          case 'attributes':
          if (mutation.attributeName == "aria-hidden") {
            if ($('.NewsletterPopup').attr('aria-hidden') == "false") {
              $('.PageOverlay').addClass('is-visible');
              $('.PageOverlay').addClass('popup-overlay');
            } else {
              $('.PageOverlay').removeClass('is-visible');
              $('.PageOverlay').removeClass('popup-overlay');
            }
          }
          break;
        }
    });
  };
  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  $('.bold-ro__one-time-purchase').click(function() {
    let src = $('*[data-source-attribute="shopify.dynamic_checkout.product.init"]').attr("src");
    let sourceAttribute = $('*[data-source-attribute="shopify.dynamic_checkout.product.init"]').attr("data-source-attribute");
    $('*[data-source-attribute="shopify.dynamic_checkout.product.init"]').remove();
    load_js(src, sourceAttribute);
  });

  function load_js(src, sourceAttribute) {
    var head= document.getElementsByTagName('head')[0];
    var script= document.createElement('script');
    script.setAttribute("data-source-attribute", sourceAttribute);
    script.src= src;
    head.appendChild(script);
  }

  $('.edit-your-plan').click(function() {
    $(this).parent().toggleClass('options-open');
    $('.options-container').slideToggle();
  });

  // always default to with subscription when changing variants
  $(document).on('variant:changed', function() {
    $('.custom-subscription-widget label').removeClass('selected');
    $('.with-subscription').addClass('selected');
  });

  $('input[name="subscription"]').change(function() {
    $('.plan-name').text($(this).val());
    if ($(this).val() == 'No Subscription') {
      $('.plan-features').hide();
    } else {
      $('.plan-features').show();
    }
  });

  $('.custom-subscription-widget .close-button').click(function() {
    $('.custom-subscription-widget').removeClass('options-open');
    $('.options-container').slideUp();
  });

  // click hidden widget button for subscription
  $('.with-subscription').click(function() {
    $('.custom-subscription-widget label').removeClass('selected');
    $(this).addClass('selected');
    $('.bold-ro__recurring-text').click();
  });

  // click hidden widget button for one time purchase
  $('.no-subscription').click(function() {
    $('.custom-subscription-widget label').removeClass('selected');
    $(this).addClass('selected');
    $('.bold-ro__one-time-purchase').click();
  });

  // additional information box functionality
  $('.info-header').click(function() {
    if ($(this).parent().hasClass('active')) {
      $(this).parent().find('.info-content').slideUp();
      $(this).parent().removeClass('active');
    } else {
      $(this).parent().addClass('active');
      $(this).parent().find('.info-content').slideDown();
    }
  });

  $(window).scroll(function() {
    for (let i = 0; i < videos.length; i++) {
      let isElementInView = Utils.isElementInView($(videos[i].element), false);

      if (isElementInView) {
          videos[i].play();
      } else {
      }
    }
  });
});


function isScrolledIntoView(elem)
{
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function Utils() {

}

Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, fullyInView) {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }
};

var Utils = new Utils();
